import { truthy } from '$utils/propValidators';
import type { CountryRow } from '../types';

const TABLE_ROW_DEFAULT_BG = 'var(--table-row-default-bg, #ffeaa5)';

export const isYes = (value: string | undefined) =>
    String(value || '')
        .trim()
        .toUpperCase() === 'X';

export const makeBackgroundValue = (value: string | undefined) => {
    const cleanValue = String(value || '').trim();
    const normalizedTruthyValue = cleanValue.replace(/^[xX]$/, 'true');

    return truthy(normalizedTruthyValue) ? TABLE_ROW_DEFAULT_BG : '#eeeeee';
};

export const hasHashPattern = (country: CountryRow, hashField?: string) => {
    if (!hashField) {
        return false;
    }

    return truthy(String(country[hashField] || '').replace(/^[xX]$/, 'true'));
};

// Sort rows by 2 fields that are passed in, and then alphabetically within each group
export const sortByFields = (
    data: CountryRow[],
    field1: string,
    field2: string
): CountryRow[] => {
    return [...data].sort((a, b) => {
        // 1) Group/sort by the first field (descending)
        const aField1 = String(a[field1] || '').toLowerCase();
        const bField1 = String(b[field1] || '').toLowerCase();

        if (aField1 > bField1) return -1;
        if (aField1 < bField1) return 1;

        // 2) Within those groups, sort by the second field (descending)
        const aField2 = String(a[field2] || '').toLowerCase();
        const bField2 = String(b[field2] || '').toLowerCase();

        if (aField2 > bField2) return -1;
        if (aField2 < bField2) return 1;

        // 3) Final tiebreaker: alphabetically by country name (ascending)
        const aCountry = String(a.country || '').toLowerCase();
        const bCountry = String(b.country || '').toLowerCase();

        return aCountry.localeCompare(bCountry);
    });
};
